module.exports = __webpack_public_path__ + "media/Images/principal-simply-retirement-logo-2397c9c9874555312cb21dc1fda3de33.svg";